import { c as _c } from "react/compiler-runtime";
import { ProductCardsRoundupBanner } from './ProductCards';
import { SummaryTableRoundupBanner } from './SummaryTable';
type Props = {
  award: string;
  variant: 'summary-table' | 'product-card';
  year?: number;
};
export function RoundupBanner(t0) {
  const $ = _c(6);
  const {
    award,
    variant,
    year
  } = t0;
  const isSummaryTable = variant === "summary-table";
  if (isSummaryTable) {
    let t1;
    if ($[0] !== award || $[1] !== year) {
      t1 = <SummaryTableRoundupBanner award={award} year={year} />;
      $[0] = award;
      $[1] = year;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== award || $[4] !== year) {
    t1 = <ProductCardsRoundupBanner award={award} year={year} />;
    $[3] = award;
    $[4] = year;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}